import React from 'react';
import { Alert, Box, Skeleton, Stack, Typography } from '@mui/material';
import { useModulePermissions } from '../../hooks/useModulePermissions';
import { useEmailSettings } from '../../components/email/useEmailSettings';
import EmailTypesCard from '../../components/email/EmailTypesCard';
import EmailSenderCard from '../../components/email/EmailSenderCard';

/**
 * Email → Setup: first which emails families get, then how they're sent
 * (sender name, replies, mailbox). Each change opens its own small dialog.
 */
const EmailSetupPage: React.FC = () => {
  const { canWrite } = useModulePermissions();
  const writable = canWrite('email');
  const { settings, setSettings, error } = useEmailSettings();

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={700}>Email setup</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Choose which emails families get. Before any of them goes out, staff see who it’s going to and confirm.
        </Typography>
      </Box>
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : !settings ? (
        <Stack spacing={2}>
          {[360, 200].map((h, i) => <Skeleton key={i} variant="rounded" height={h} sx={{ borderRadius: 2.5 }} />)}
        </Stack>
      ) : (
        <Stack spacing={2.5}>
          <EmailTypesCard settings={settings} writable={writable} onChange={setSettings} />
          <EmailSenderCard settings={settings} writable={writable} onChange={setSettings} />
        </Stack>
      )}
    </Box>
  );
};

export default EmailSetupPage;
